// extracted by css-extract-rspack-plugin
export default {"cls1":"fadeTransition-cls1_VtX","cls2":"fadeTransition-cls2_nk- fadeTransition-cls1_VtX"};